module.exports = __webpack_public_path__ + "img/role_type.e7c3eecc.svg";